import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute, Link, redirect } from '@tanstack/react-router'

import { ArrowUpRightOnBox } from '@/components/icons'
import { Button } from '@/components/ui/button'
import { PageCard, PageLayout, PageTwoColumn } from '@/components/ui/page'

import { useAuth } from '@/libs/hooks/use-auth'

import { accountStaffList } from '@/features/account/api'
import { outletMasterDetail } from '@/features/outlet/api'

export const Route = createFileRoute('/_app/outlet/')({
	loader: async ({ context }) => {
		const outletId = useAuth.getState().outlet?.outletId
		if (!outletId) throw redirect({ to: '/' })

		await context.qc.ensureQueryData(outletMasterDetail.qry({ id: outletId }))
	},
	component: RouteComponent,
})

function RouteComponent() {
	return (
		<PageLayout>
			<PageLayout.Header breadcrumbs={[[Route.fullPath, 'Outlet']]} />
			<PageTwoColumn>
				<PageTwoColumn.Main>
					<GeneralCard />
				</PageTwoColumn.Main>
				<PageTwoColumn.Sidebar>
					<StaffInfoCard />
				</PageTwoColumn.Sidebar>
			</PageTwoColumn>
		</PageLayout>
	)
}

function useOutletData() {
	const outletId = useAuth((s) => s.outlet.outletId)
	const { data } = useSuspenseQuery(outletMasterDetail.qry({ id: outletId }))
	return data
}

function GeneralCard() {
	const { outlet } = useOutletData()

	return (
		<PageCard>
			<PageCard.Header title="Informasi Outlet" />
			<PageCard.ContentRow title="Outlet" value={outlet.name} />
			<PageCard.ContentRow title="Email" value={outlet.email} />
			<PageCard.ContentRow title="Alamat" value={outlet.address} />
			<PageCard.ContentRow title="Deskripsi" value={outlet.desc} />
			<PageCard.ContentRow title="Nomor Telepon" value={outlet.phone} />
		</PageCard>
	)
}

function StaffInfoCard() {
	const { outlet } = useOutletData()
	const {
		data: { total },
	} = useSuspenseQuery(accountStaffList.qry({ oId: outlet.id }))

	return (
		<PageCard>
			<PageCard.Header
				title="Total Karyawan"
				actions={
					<div>
						<Button asChild>
							<Link to="/outlet/staff">
								<ArrowUpRightOnBox />
								{total || 0} Karyawan
							</Link>
						</Button>
					</div>
				}
			/>
		</PageCard>
	)
}
